import { appAxios } from '@/network/base/appAxios';
import axios from 'axios';

export async function getPresignedUrl(fileName, contentType, folderName) {
  try {
    const response = await appAxios.post('/S3presigned/v1.0/get-upload-url', {
      fileName,
      contentType,
      folderName,
    });
    return { data: response.data.data, error: null };
  } catch (error) {
    console.error('getPresignedUrl error:', error);
    return { data: null, error };
  }
}

export async function getAdminPresignedUrl(fileName, contentType, folderName) {
  try {
    const response = await appAxios.post('/S3presigned/v1.0/get-admin-upload-url', {
      fileName,
      contentType,
      folderName,
    });
    return { data: response.data.data, error: null };
  } catch (error) {
    console.error('getPresignedUrl error:', error);
    return { data: null, error };
  }
}

export async function uploadToS3(file, folderName, isAdmin = false) {
  try {
    if (isAdmin) {
      const { data, error } = await getAdminPresignedUrl(file.name, file.type, folderName);
      if (error) throw error;
      await axios.put(data.uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
        transformRequest: [(data) => data],
      });

      return {
        data: {
          fileUrl: data.fileUrl,
          key: data.key,
        },
        error: null,
      };
    } else {

      const { data, error } = await getPresignedUrl(file.name, file.type, folderName);
      if (error) throw error;
      await axios.put(data.uploadUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
        transformRequest: [(data) => data],
      });

      return {
        data: {
          fileUrl: data.fileUrl,
          key: data.key,
        },
        error: null,
      };
    }
  } catch (error) {
    console.error('uploadToS3 error:', error);
    return { data: null, error };
  }
}